import { call, put } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import get from 'lodash/get'

import makeAPIRequest from 'store/entities/api/sagas'
import { showInfo, showSuccess } from 'store/entities/toastr/utils'
import { parseReduxFormErrorsFromResponse } from 'helpers'

export function* makeRequest({ type, payload }) {
  try {
    // TODO: handle type checking by flow
    if (!payload || payload.request === undefined) {
      throw new Error('payload.request field required for request action!')
    }
    if (payload.form) {
      yield put(startSubmit(payload.form))
    }
    const preparedRequest = { ...payload.request }
    const url = preparedRequest.url
    delete preparedRequest.url
    if (!preparedRequest.method) {
      preparedRequest.method = 'GET'
    }
    const response = yield call(makeAPIRequest, url, preparedRequest, undefined, false)
    const preparedResponse = response.data
    yield put({ type: `${type}_SUCCESS`, payload: preparedResponse, meta: { ...payload } })
    if (payload.success) {
      if (typeof payload.success === 'function') {
        payload.success = payload.success(preparedResponse)
      }
      showSuccess(typeof payload.success === 'string' ? { content: payload.success } : payload.success)
    }
    if (payload.form) {
      yield put(stopSubmit(payload.form))
    }
    return response
  } catch (error) {
    // TODO: prepare error for make it universal
    const universalError = error.data ? error.data : error
    yield put({ type: `${type}_FAIL`, payload: universalError, meta: { ...payload } })
    if (payload.form) {
      const parsedErrors = parseReduxFormErrorsFromResponse(error)
      yield put(stopSubmit(payload.form, parsedErrors))
      showInfo({ content: parsedErrors._error })
    } else if (payload.fail) {
      showInfo(typeof payload.fail === 'string' ? { content: payload.fail } : payload.fail)
    } else {
      const content = get(error, ['data', 'message'], undefined)
      showInfo({ content })
    }

    return error
  }
}
